import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { UnifiedLoanService } from '../../services/unifiedLoanService';
import { GENERIC_ERROR_MESSAGE } from 'libs/feature-utils/src/utils/constants';

const PAGE_SIZE = 10;
export class UnifiedPipelineLoansGridStore extends GridStore {
  globalStore: GlobalStore;
  unifiedLoanService: UnifiedLoanService;

  private offsets: [number, number] = [0, 0];
  private totalCount: number = 0;

  constructor(globalStore: GlobalStore) {
    super(() => this.fetchUnifiedLoans(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.unifiedLoanService = new UnifiedLoanService();
  }

  reset() {
    super.reset();
    this.offsets = [0, 0];
  }

  *setPageNumber(pageNumber, fetch = true): any {
    this.offsets = pageNumber === 1 ? [0, 0] : this.offsets;
    yield super.setPageNumber(pageNumber, fetch);
  }

  fetchUnifiedLoans = async () => {
    try {
      const filters = {
        ...this.gridData.meta.filters,
        priority: this.gridData.meta.dropdownFilters?.priority,
      };
      const { capitalProvider, status, ...dropdownFilters } =
        this.gridData.meta.dropdownFilters || {};
      const externalStatus = status;

      const response: ApiResponse = await this.unifiedLoanService.getMyPipelineLoans(
        this.gridData.meta.pageNumber,
        this.gridData.meta.pageSize,
        this.gridData.meta.sortDir,
        this.gridData.meta.sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        this.offsets,
        capitalProvider
      );
      this.totalCount = response.data.data.totalCount;
      this.offsets = response.data?.data.offsets || [0, 0];
      response.data.data.totalCount = Math.min(
        this.totalCount,
        (this.offsets?.[0] || 0) +
          (this.offsets?.[1] || 0) +
          this.gridData.meta.pageSize
      );

      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  };
}
